import { createReducer, on, Action } from '@ngrx/store';

import { shopCartInitialState, ShopCartState } from './shopcart.state';

import { Adjustment, CartTax } from '@api/cart/cart.models';
import * as Actions from '@shared/shopcart/store/shopcart.actions';

/**
 * Definicion de las acciones que implementa el "userReducer"
 */
const shopCartReducerDefinition = createReducer(
    shopCartInitialState,

    on(Actions.LoadShopCartSuccess, (state: ShopCartState, { shopcart }): any => {
        return {
            ...state,
            id: shopcart?.id,
            cart: { ...shopcart },
            loaded: true,
            loading: false,
        };
    }),
    on(Actions.SetShopCartSuccess, (state: ShopCartState, {
        showMoreMessage, moreMessage, moreItems, itemsInCart,
    }): any => {
        return {
            ...state,
            showMoreMessage,
            moreMessage,
            moreItems,
            itemsInCart,
            pendingCart: [],
        };
    }),
    on(Actions.LoadShopCartError, (state: ShopCartState, { errors }): ShopCartState => {
        return {
            ...state,
            cart: {
                ...state.cart,
                errors,
            },
            loading: false,
        };
    }),
    on(Actions.ShowAllItems, (state: ShopCartState): ShopCartState => {
        return {
            ...state,
            showAllItems: true,
            showMoreMessage: false,
        };
    }),

    on(Actions.ResetCartError, (state: ShopCartState): any => {
        return {
            ...state,
            cart: {
                ...state.cart,
                errors: [],
            },
        };
    }),

    on(
        Actions.SetShopCartShippingCosts,
        (
            state: ShopCartState,
            payload: {
                adjustment: Adjustment[];
                shippingPrice: number;
                shippingTax: number;
                totalOrder: number;
                taxArray: CartTax[];
                tax: number;
            }
        ): ShopCartState => {
            return {
                ...state,
                cart: {
                    ...state.cart,
                    ...payload,
                },
            };
        }
    ),
    on(Actions.LoadGiftPackageDataSuccess, (state: ShopCartState, { boxes }): any => {
        return {
            ...state,
            giftBoxes: boxes,
        };
    }),
    on(Actions.SetShopcartItemsStock, (state: ShopCartState, { stockItems }): any => {
        return { ...state, stockItems };
    }),

    on(Actions.SetShopcartItemsSizes, (state: ShopCartState, { sizesItems }): any => {
        return { ...state, sizesItems };
    }),

    on(Actions.SetShopcartItemsInCart, (state: ShopCartState, { itemsInCart }): any => {
        return { ...state, itemsInCart };
    }),

    on(Actions.AddItemsPendingGetCart, (state: ShopCartState, { itemsPending }): any => {
        return {
            ...state,
            pendingCart: [
                ...state.pendingCart,
                ...itemsPending,
            ],
        };
    }),
);

/**
 * Reducer para el usuario actual
 */
export function shopCartReducer(state: ShopCartState, action: Action): ShopCartState {
    return shopCartReducerDefinition(state, action);
}
